import { render, staticRenderFns, recyclableRender, components } from "./role.vue?vue&type=template&id=7ff2aec6&scoped=true&"
var renderjs
import script from "./role.vue?vue&type=script&lang=js&"
export * from "./role.vue?vue&type=script&lang=js&"
import style0 from "./role.vue?vue&type=style&index=0&id=7ff2aec6&lang=scss&scoped=true&"
import style1 from "./role.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff2aec6",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/role/role.vue"
export default component.exports